/*eslint-disable*/
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import AlertDialog from "../../components/AlertDialog";
import CircularLoading from "../../components/CircularLoading";
import MaterialTable from "material-table";
import React, { useContext, useEffect, useState } from "react";
import { FirebaseContext } from "common";
import {
  features,
  language,
  otc,
  prescription as prescript,
  condition,
} from "config";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { Add } from "@material-ui/icons";
import UsersCombo from "components/UsersCombo";

import {
  Dialog,
  DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Header from "components/Header/Header";

export default function DrugExposure({ Booking }) {
  const { api } = useContext(FirebaseContext);
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
    updateProfile,
    updateBooking,
    fetchOtc,
  } = api;
  const [state, setState] = useState({
    drug_exposure_id: "",
    person_id: "",
    drug_concept_id: "",
    drug_exposure_start_date: "",
    drug_exposure_start_datetime: "",
    drug_exposure_end_date: "",
    drug_exposure_end_datetime: "",
    verbatim_end_date: "",
    drug_type_concept_id: "",
    stop_reason: "",
    refills: "",
    quantity: "",
    days_supply: "",
    sig: "",
    route_concept_id: "",
    lot_number: "",
    provider_id: "",
    visit_occurrence_id: "",
    visit_detail_id: "",
    drug_source_value: "",
    drug_source_concept_id: "",
    route_source_value: "",
    dose_unit_source_value: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });
  const location = useLocation();
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [updatebooking, setupdatebooking] = useState(Booking);
  const [details, setdetails] = useState(location.state.Booking);
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const otcdata = useSelector((state) => state.drugdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openFPModal, setOpenFPModal] = React.useState(false);
  // const [otc, setotc] = useState([]);
  const [otcT, setotcT] = useState([]);
  const [prescripts, setprescripts] = useState([]);
  const [conditions, setconditions] = useState([]);
  useEffect(() => {
    if (details) {
      setData(Object.values(details.prescription));
      console.log(" data from useffect :", [Object.values(details.prescription)]);
      
    } else {
      setData([]);
      console.log("data:", data);
    }
  }, [details]);
  useEffect(() => {
    console.log("otcdata", prescript);
  }, [prescript]);

  useEffect(() => {
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }

      setSpecialityTypes(obj);
    }
    if (otc) {
      let arr = {};
      for (let i = 0; i < otc.length; i++) {
        otc.map((otcs) => (arr[otcs.concept_name] = otcs.concept_name));
      }
      setotcT(Object.values(arr));
    }
    if (prescript) {
      let arr = {};
      for (let i = 0; i < prescript.length; i++) {
        prescript.map((pres) => (arr[pres.concept_name] = pres.concept_name));
      }
      setprescripts(Object.values(arr));
    }
    if (condition) {
      let arr = {};
      for (let i = 0; i < condition.length; i++) {
        condition.map((con) => (arr[con.concept_name] = con.concept_name));
      }
      setconditions(Object.values(arr));
    }
  }, []);

  

  
  const columns = [
    { header: language.personid, accessorKey: "person_id" },
    { header: language.drug_concept_id, accessorKey: "drug_concept_id" },
    { header: language.startdate, accessorKey: "drug_exposure_start_date" ,  type: "date" },
    { header: language.start_datetime, accessorKey: "drug_exposure_start_datetime" ,  type: "date"},
    { header: language.drug_source_value, accessorKey: "drug_source_value" },
    // { header: language.drug_source_concept_id, accessorKey: "drug_source_concept_id" },
    { header: language.route_source_value, accessorKey: "route_source_value" },
    { header: language.dose_unit_source_value, accessorKey: "dose_unit_source_value" },
  ];
  
 

  console.log("Columns:", columns);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    setOpenFPModal(false);
  };

const onRowAdd = (newData) =>{
  new Promise((resolve, reject) => {
    resolve();
    setTimeout(() => {
      newData.person_id = details.patient;
      let tempArr = data;
      tempArr.push(newData);
      setData([...tempArr]);
      dispatch(
        updateBooking({ ...details, prescription: tempArr })
      );
    }, 800);
  })}


 const onRowUpdate = (newData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        let tempArr = data;
        const indexOf = data.indexOf(newData);

        console.log("newData", newData);

        if (indexOf > -1) {
          tempArr[indexOf] = newData;
          setData([...tempArr]);
          dispatch(
            updateBooking({ ...details, prescription: tempArr })
          );
          resolve();
        } else {
          setCommonAlert({
            open: true,
            msg: "No note found cant update",
          });
          resolve();
        }

        dispatch(editUser(newData.person_id, newData));
      }, 600);
    })}

 const onRowDelete = (oldData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        let tempArr = data;
        const indexOf = data.indexOf(oldData);
        if (indexOf > -1) {
          tempArr.splice(indexOf, 1);
          setData([...tempArr]);
          dispatch(
            updateBooking({ ...details, prescription: tempArr })
          );
          resolve();
        } else {
          setCommonAlert({
            open: true,
            msg: "No note found cant delete",
          });
          resolve();
        }
      }, 600);
    })}




  // const onChangeHandle = (e) => {
  //   // setotcT(e);
  //   let otcdata = e;
  //   dispatch(fetchOtc(otcdata));
  //   console.log("this is the search: ", otcdata);
  // };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        // columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
